/**
 * MAMAVIBEZ - INTERACTIVE REVIEWS & COMMENTS ENGINE
 */

document.addEventListener('DOMContentLoaded', () => {
  const reviewsSection = document.getElementById('ProductReviewsSection');
  if (!reviewsSection) return;

  const productId = reviewsSection.dataset.productId || 'default';
  const STORAGE_KEY = `mamavibez_reviews_${productId}`;

  // Toggle Write Review Form
  const writeBtn = document.getElementById('WriteReviewBtn');
  const writeDrawer = document.getElementById('WriteReviewDrawer');
  const cancelBtn = document.getElementById('CancelReviewBtn');

  if (writeBtn && writeDrawer) {
    writeBtn.addEventListener('click', () => {
      writeDrawer.hidden = !writeDrawer.hidden;
      if (!writeDrawer.hidden) {
        writeDrawer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    cancelBtn?.addEventListener('click', () => {
      writeDrawer.hidden = true;
    });
  }

  // Interactive Star Selector
  let selectedRating = 5;
  const stars = document.querySelectorAll('.star-rating-star');
  const ratingInput = document.getElementById('ReviewRatingInput');

  stars.forEach((star) => {
    star.addEventListener('click', () => {
      selectedRating = parseInt(star.dataset.val, 10);
      if (ratingInput) ratingInput.value = selectedRating;
      updateStarsUI(selectedRating);
    });

    star.addEventListener('mouseenter', () => {
      const val = parseInt(star.dataset.val, 10);
      updateStarsUI(val);
    });
  });

  const starSelector = document.querySelector('.star-rating-selector');
  starSelector?.addEventListener('mouseleave', () => {
    updateStarsUI(selectedRating);
  });

  function updateStarsUI(rating) {
    stars.forEach((s) => {
      const val = parseInt(s.dataset.val, 10);
      s.classList.toggle('is-selected', val <= rating);
    });
  }

  // Load User Submitted Reviews from LocalStorage
  const userReviewsList = document.getElementById('UserReviewsList');
  function loadUserReviews() {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (!userReviewsList) return;

    if (saved.length > 0) {
      userReviewsList.innerHTML = saved.map((r) => `
        <div class="review-card-item">
          <div class="review-card-top">
            <div class="review-card-stars">
              ${'★'.repeat(r.rating)}${'☆'.repeat(5 - r.rating)}
            </div>
            <span class="verified-buyer-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
              Verified Buyer
            </span>
          </div>
          <h4 class="review-card-header">${escapeHTML(r.title)}</h4>
          <p class="review-card-body">${escapeHTML(r.comment)}</p>
          <div class="review-card-author-row">
            <div>
              <span class="review-author-name">${escapeHTML(r.name)}</span>
              <span class="review-author-location">• ${escapeHTML(r.city || 'India')}</span>
            </div>
            <span class="caption text-muted">${r.date || 'Just now'}</span>
          </div>
        </div>
      `).join('');
    }
  }

  loadUserReviews();

  // Review Form Submit Handler
  const form = document.getElementById('NewReviewForm');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const name = document.getElementById('ReviewAuthorName')?.value.trim();
      const city = document.getElementById('ReviewAuthorCity')?.value.trim();
      const title = document.getElementById('ReviewHeadline')?.value.trim();
      const comment = document.getElementById('ReviewComment')?.value.trim();

      if (!name || !title || !comment) {
        window.showToast('Please fill out all required fields.');
        return;
      }

      const newReview = {
        rating: selectedRating,
        name: name,
        city: city || 'Verified Buyer',
        title: title,
        comment: comment,
        date: 'Today'
      };

      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      saved.unshift(newReview);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));

      loadUserReviews();

      form.reset();
      selectedRating = 5;
      updateStarsUI(5);
      if (writeDrawer) writeDrawer.hidden = true;

      window.showToast('🎉 Thank you! Your review has been published.');
    });
  }

  // Helpful Upvote Buttons
  document.addEventListener('click', (e) => {
    const helpfulBtn = e.target.closest('[data-helpful-btn]');
    if (helpfulBtn) {
      const countEl = helpfulBtn.querySelector('.helpful-count');
      let count = parseInt(countEl?.textContent || '0', 10);
      if (!helpfulBtn.classList.contains('is-voted')) {
        helpfulBtn.classList.add('is-voted');
        if (countEl) countEl.textContent = count + 1;
        window.showToast('Thank you for your feedback!');
      }
    }
  });

  // Load More Reviews Toggle Handler (Hides 5+ reviews by default, reveals on click)
  const loadMoreBtn = document.getElementById('LoadMoreReviewsBtn');
  const loadMoreWrap = document.getElementById('ReviewsLoadMoreWrap');
  let isExpanded = false;

  function updateLoadMoreState() {
    const hiddenReviews = document.querySelectorAll('#MerchantReviewsList .is-hidden-review');
    if (loadMoreWrap) {
      if (hiddenReviews.length === 0 && !isExpanded) {
        loadMoreWrap.style.display = 'none';
      } else {
        loadMoreWrap.style.display = 'block';
        if (loadMoreBtn && !isExpanded) {
          loadMoreBtn.innerHTML = `More Reviews (${hiddenReviews.length} Remaining) &darr;`;
        }
      }
    }
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      const allReviews = document.querySelectorAll('#MerchantReviewsList .review-card-item');
      isExpanded = !isExpanded;

      allReviews.forEach((card, index) => {
        if (index >= 4) {
          if (isExpanded) {
            card.classList.remove('is-hidden-review');
          } else {
            card.classList.add('is-hidden-review');
          }
        }
      });

      if (isExpanded) {
        loadMoreBtn.innerHTML = `Show Less &uarr;`;
      } else {
        const remaining = Array.from(allReviews).slice(4).length;
        loadMoreBtn.innerHTML = `More Reviews (${remaining} Remaining) &darr;`;
        document.getElementById('ProductReviewsSection')?.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  updateLoadMoreState();

  function escapeHTML(str) {
    return str.replace(/[&<>'"]/g, 
      tag => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[tag] || tag)
    );
  }
});
